<template>
  <fn-form
    v-slot="form"
    :errors="errors"
    :loading="loading"
    @submit="$emit('submit', $event.values)"
    @form-loaded="updatePasswordForm = $event"
  >
    <fn-form-errors :errors="errors" />
    <fn-form-group v-if="!hideOldPassword">
      <fn-form-section>
        <fn-form-field-password
          id="oldPassword"
          :label="$t('forms.account.editAccountPassword.fields.passwordCurrent.label')"
          :password-strength-visible="false"
          :rules="{
            required: {
              message: $t('validation.fields.passwordOld.required'),
            },
          }"
          hide-required-asterix
          name="oldPassword"
        />
      </fn-form-section>
    </fn-form-group>

    <fn-form-group>
      <fn-form-section>
        <fn-form-field-password
          id="newPassword"
          :label="$t('forms.account.editAccountPassword.fields.passwordNew.label')"
          :rules="{
            min: 8,
            max: 32,
            min_1_number: true,
            min_1_large_alpha: true,
            min_1_small_alpha: true,
            min_1_special_char: true,
            required: {
              message: $t('validation.fields.passwordNew.required'),
            },
          }"
          hide-required-asterix
          name="newPassword"
        />
      </fn-form-section>
    </fn-form-group>

    <fn-form-group>
      <fn-form-section>
        <fn-form-field-password
          id="newPasswordRepeat"
          :label="$t('forms.account.editAccountPassword.fields.passwordRepeat.label')"
          :password-strength-visible="false"
          :rules="{
            required: {
              message: $t('validation.fields.passwordNewRepeat.required'),
            },
            confirmed: {
              target: form.values.newPassword,
              message: $t('validation.fields.password.unconfirmed'),
            },
          }"
          hide-required-asterix
          name="newPasswordRepeat"
        />
      </fn-form-section>
    </fn-form-group>

    <fn-form-group>
      <fn-form-section>
        <fn-action-box-notification plain>
          <div v-html="$t('forms.account.editAccountPassword.info')" />
        </fn-action-box-notification>
      </fn-form-section>
    </fn-form-group>

    <fn-form-group>
      <fn-form-section>
        <fn-button
          id="formUpdatePassword-submit"
          full-width
          secondary
          submit
        >
          {{ $t('forms.account.editAccountPassword.buttons.save') }}
        </fn-button>
      </fn-form-section>
    </fn-form-group>
  </fn-form>
</template>

<script lang="ts">
export default {
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
    },
    hideOldPassword: {
      type: Boolean,
    },
  },
  emits: ['submit'],
  data() {
    return {
      updatePasswordForm: {},
    };
  },
};
</script>
